import { TARGET_EPSILON_PX } from "@/app/_hooks/Timeline/spaceSegmentScrollUtils";

type ScrollAnimationOptions = {
  owner: HTMLElement;
  targetLeft: number;
  targetTop: number;
  isCurrentJob: () => boolean;
  finishCurrentJob: () => void;
  setWatchRaf: (rafId: number) => void;
};

export function runManualSmoothScroll({
  owner,
  targetLeft,
  targetTop,
  isCurrentJob,
  finishCurrentJob,
  setWatchRaf,
}: ScrollAnimationOptions) {
  const fromLeft = owner.scrollLeft;
  const fromTop = owner.scrollTop;
  const deltaLeft = targetLeft - fromLeft;
  const deltaTop = targetTop - fromTop;
  if (
    Math.abs(deltaLeft) <= TARGET_EPSILON_PX &&
    Math.abs(deltaTop) <= TARGET_EPSILON_PX
  ) {
    finishCurrentJob();
    return;
  }
  let startTs: number | null = null;
  const durationMs = 280;
  const animate = (timestamp: number) => {
    if (!isCurrentJob()) return;
    if (startTs == null) startTs = timestamp;
    const progress = Math.min(1, (timestamp - startTs) / durationMs);
    const eased = 1 - Math.pow(1 - progress, 3);
    owner.scrollLeft = fromLeft + deltaLeft * eased;
    owner.scrollTop = fromTop + deltaTop * eased;
    if (progress >= 1) {
      finishCurrentJob();
      return;
    }
    setWatchRaf(requestAnimationFrame(animate));
  };
  setWatchRaf(requestAnimationFrame(animate));
}
